import { render, staticRenderFns } from "./AttachedFiles.vue?vue&type=template&id=5a01c499&scoped=true&"
import script from "./AttachedFiles.vue?vue&type=script&lang=js&"
export * from "./AttachedFiles.vue?vue&type=script&lang=js&"
import style0 from "./AttachedFiles.vue?vue&type=style&index=0&id=5a01c499&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01c499",
  null
  
)

export default component.exports